import { defineStore } from 'pinia';
import { useLocalStorage } from '@vueuse/core';

export const useCredentialsStore = defineStore('credentials', {
  state: () => ({
    credentials: useLocalStorage('credentials', {
      postal_code: null,
      plant_code: null,
    }),
  }),
  getters: {
    isSignedIn(state) {
      return (
        state.credentials.postal_code !== null &&
        state.credentials.plant_code !== null
      );
    },
  },
  actions: {
    set(postalCode, plantCode) {
      this.credentials.postal_code = postalCode;
      this.credentials.plant_code = plantCode;
    },
    clear() {
      this.credentials.postal_code = null;
      this.credentials.plant_code = null;
    },
  },
});
